import { Text } from '@mantine/core';
import { IconShield } from '@tabler/icons-react';
import { match } from 'ts-pattern';
import type { AIMessage } from '~/common/vm/protocol';
import type { AssertionMethod } from '~/ai_tools/playwright_utils/types';
import { CollapsibleCard } from '../CollapsibleCard';

function getAssertionDisplayName(assertionType: AssertionMethod): string {
  return match(assertionType)
    .with('toBeAttached', () => 'to be attached')
    .with('toBeChecked', () => 'to be checked')
    .with('toBeDisabled', () => 'to be disabled')
    .with('toBeEditable', () => 'to be editable')
    .with('toBeEmpty', () => 'to be empty')
    .with('toBeEnabled', () => 'to be enabled')
    .with('toBeFocused', () => 'to be focused')
    .with('toBeHidden', () => 'to be hidden')
    .with('toBeInViewport', () => 'to be in viewport')
    .with('toBeVisible', () => 'to be visible')
    .with('toContainText', () => 'to contain text')
    .with('toHaveAttribute', () => 'to have attribute')
    .with('toHaveClass', () => 'to have class')
    .with('toHaveCount', () => 'to have count')
    .with('toHaveCSS', () => 'to have CSS')
    .with('toHaveId', () => 'to have ID')
    .with('toHaveJSProperty', () => 'to have JS property')
    .with('toHaveScreenshot', () => 'to have screenshot')
    .with('toHaveText', () => 'to have text')
    .with('toHaveValue', () => 'to have value')
    .with('toHaveValues', () => 'to have values')
    .exhaustive();
}

export function AIAssertionCard({ message }: { message: Extract<AIMessage, { type: 'assertion' }> }) {
  return (
    <CollapsibleCard
      icon={IconShield}
      title="Assertion"
      defaultExpanded={true}
      classNames={{
        icon: 'text-gray-500 dark:text-gray-400',
      }}
    >
      <div>
        {message.assertionType || message.target ?
          <div className="flex flex-wrap items-center gap-2">
            <Text
              size="sm"
              className="font-medium"
            >
              Expect
            </Text>
            {!!message.target && (
              <div className="rounded border border-gray-200 bg-gray-50 px-2 py-1 dark:border-gray-700 dark:bg-gray-800">
                <Text
                  size="sm"
                  className=""
                >
                  {message.target}
                </Text>
              </div>
            )}
            {!!message.assertionType && (
              <div className="rounded border border-gray-200 bg-gray-50 px-2 py-1 dark:border-gray-700 dark:bg-gray-800">
                <Text
                  size="sm"
                  className="font-medium"
                >
                  {getAssertionDisplayName(message.assertionType)}
                  {message.value ? ` "${message.value}"` : ''}
                </Text>
              </div>
            )}
          </div>
        : <Text
            size="sm"
            className="leading-relaxed"
          >
            Assertion completed
          </Text>
        }
      </div>
    </CollapsibleCard>
  );
}
